import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const CalendrierDetailRemoveDialog = ({ isOpen, setIsOpen, selectedHoliday, handleRemoveHoliday }) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{t("holidayCalendarComponents.removeHolidayDialog.title")}</AlertDialogTitle>
        <AlertDialogDescription>
          {t("holidayCalendarComponents.removeHolidayDialog.desc", { name: selectedHoliday?.name })}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>{t("holidayCommon.cancel")}</AlertDialogCancel>
        <AlertDialogAction onClick={handleRemoveHoliday} className="bg-red-600 hover:bg-red-700">
          {t("holidayCalendarComponents.removeHolidayDialog.remove")}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
    </AlertDialog>
  );
};

export default CalendrierDetailRemoveDialog;
